<script lang="ts">
  import {FontFamilies} from '@/types/metadata';
  import {getImage} from '@/utils/common';
</script>

<svelte:head>
  <title>Create - Sermon Shots</title>
  <meta name="HandheldFriendly" content="true" />
  <meta name="MobileOptimized" content="320" />
  <meta name="viewport" content="initial-scale=1.0, maximum-scale=1.0, width=device-width, user-scalable=no" />
  <link rel="icon" type="image/png" href={getImage('favicon.png')} />
  {#each FontFamilies as font}
    {#if font !== 'default'}
      <link href="https://fonts.googleapis.com/css?family={font}" rel="stylesheet" />
    {/if}
  {/each}

  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
  />

  <style>
    html,
    body {
      height: 100% !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  </style>
</svelte:head>
